document.querySelectorAll( '.b-our-locations' ).forEach( ( block ) => {

	const countrySection = block.querySelector( '.locations__section:not(.locations__section--cities)' );
	const citiesSection = block.querySelector( '.locations__section--cities' );
	const countryChips = block.querySelectorAll( '.locations__chip[data-country]' );
	const backButton = block.querySelector( '.locations__back' );
	const citiesTitle = block.querySelector( '#cities-title' );
	const citiesContainer = citiesSection.querySelector( '.locations__chips' );
	const detailsContainer = block.querySelector( '.locations__details' );
	const mapContainer = block.querySelector( '.locations__map__wrapper' );

	const globalMapUrl = `${window.location.origin}/wp-content/themes/btc/img/blocks/our-locations/world-map.svg`;

	/**
	 * Handle country chip click
	 *
	 * @param {Event} event Click event
	 */
	function handleCountryClick( event ) {

		const button = event.currentTarget;
		const countryId = button.dataset.country;

		if ( !countryId ) {

			return;

		}

		const countryName = button.textContent.trim();

		citiesTitle.textContent = countryName;
		citiesContainer.innerHTML = '<div class="locations__loading">Loading locations...</div>';
		citiesContainer.classList.add( 'locations__chips--loading' );
		detailsContainer.innerHTML = '';

		countrySection.hidden = true;
		citiesSection.hidden = false;

		const formData = new FormData();
		formData.append( 'action', 'get_locations_by_country' );
		formData.append( 'country_id', countryId );
		formData.append( 'nonce', window.locationsAjax.nonce );

		fetch( window.locationsAjax.ajaxUrl, {
			method: 'POST',
			body: formData,
		} )
			.then( response => response.json() )
			.then( data => {

				citiesContainer.classList.remove( 'locations__chips--loading' );

				if ( data.success && data.data.locations_html ) {

					citiesContainer.innerHTML = data.data.locations_html;
					updateCountryMap( data.data.map_url, data.data.coordinates );
					attachLocationListeners();

				} else {

					updateCountryMap( null );

				}

			} )
			.catch( () => {

				citiesContainer.classList.remove( 'locations__chips--loading' );

			} );

	}

	/**
	 * Update country map with SVG and display location points
	 *
	 * @param {string|null} mapUrl URL to SVG file
	 * @param {Object} coordinates Coordinates data from server
	 * @param {Element} targetContainer Target map container (optional, defaults to desktop)
	 */
	function updateCountryMap( mapUrl, coordinates = {}, targetContainer = null ) {

		const container = targetContainer || mapContainer;

		if ( !container ) {

			return;

		}

		if ( !mapUrl ) {

			container.innerHTML = '<div class="locations__map-placeholder">No map available for this country</div>';
			return;

		}

		container.innerHTML = '<div class="locations__map-loading">Loading map...</div>';

		fetch( mapUrl )
			.then( response => {

				if ( !response.ok ) {

					throw new Error( 'Failed to load map' );

				}

				return response.text();

			} )
			.then( svgContent => {

				container.innerHTML = svgContent;

				displayMapPoints( coordinates, container );

			} )
			.catch( () => {

				container.innerHTML = '<div class="locations__map-error">Error loading map</div>';

			} );

	}

	/**
	 * Display location points on the loaded SVG map
	 *
	 * @param {Object} coordinates Coordinates data from server
	 * @param {Element} targetContainer Target map container (optional, defaults to desktop)
	 */
	function displayMapPoints( coordinates, targetContainer = null ) {

		const container = targetContainer || mapContainer;

		if ( !container || !coordinates || Object.keys( coordinates ).length === 0 ) {

			return;

		}

		const existingPoints = container.querySelectorAll( '.locations__map-point' );
		existingPoints.forEach( point => point.remove() );

		Object.entries( coordinates ).forEach( ( [ postId, locationData ] ) => {

			const { post_title: postTitle, coordinates: locationCoordinates } = locationData;

			locationCoordinates.forEach( ( coord, index ) => {

				const point = document.createElement( 'div' );
				point.className = 'locations__map-point';
				point.setAttribute( 'data-post-id', postId );
				point.setAttribute( 'data-point-index', index );
				point.setAttribute( 'title', postTitle );

				point.style.cssText = `
					position: absolute;
					left: ${coord.posx}%;
					top: ${coord.posy}%;
					z-index: 10;
				`;

				const marker = document.createElement( 'span' );
				marker.className = 'locations__map-point__marker';
				point.appendChild( marker );

				// const label = document.createElement( 'span' );
				// label.className = 'locations__map-point__label';
				// label.textContent = postTitle;
				// point.appendChild( label );

				point.addEventListener( 'click', ( event ) => {

					event.preventDefault();
					handleMapPointClick( postId, postTitle );

				} );

				point.addEventListener( 'mouseenter', ( event ) => {

					event.preventDefault();
					highlightCityButton( postId );

				} );

				point.addEventListener( 'mouseleave', ( event ) => {

					event.preventDefault();
					clearCityButtonHighlight();

				} );

				container.appendChild( point );

			} );

		} );

	}

	/**
	 * Handle map point click
	 *
	 * @param {string} postId Post ID
	 */
	function handleMapPointClick( postId ) {

		const locationChip = citiesContainer.querySelector( `[data-location="${postId}"]` );
		if ( locationChip ) {

			locationChip.click();

		}

	}

	/**
	 * Highlight city button when map point is hovered
	 *
	 * @param {string} postId Post ID
	 */
	function highlightCityButton( postId ) {

		const locationChip = citiesContainer.querySelector( `[data-location="${postId}"]` );
		if ( locationChip ) {

			locationChip.classList.add( 'active' );

		}

	}

	/**
	 * Clear all city button highlights
	 */
	function clearCityButtonHighlight() {

		const locationChips = citiesContainer.querySelectorAll( '.locations__chip[data-location]' );
		locationChips.forEach( chip => {

			chip.classList.remove( 'active' );

		} );

	}

	/**
	 * Attach event listeners to location chips
	 *
	 * @param {boolean} isPopup Whether to attach listeners for popup context
	 */
	function attachLocationListeners( isPopup = false ) {

		const targetContainer = isPopup ? popupCitiesChips : citiesContainer;

		if ( !targetContainer ) {

			return;

		}

		const locationChips = targetContainer.querySelectorAll( '.locations__chip[data-location]' );
		locationChips.forEach( chip => {

			chip.addEventListener( 'click', ( event ) => handleLocationClick( event, isPopup ) );

		} );

		setupCityHoverHighlight( isPopup );

	}

	/**
	 * Handle location chip click
	 *
	 * @param {Event} event Click event
	 * @param {boolean} isPopup Whether click is from popup context
	 */
	function handleLocationClick( event, isPopup = false ) {

		const button = event.currentTarget;
		const locationId = parseInt( button.dataset.location );

		const targetChipsContainer = isPopup ? popupCitiesChips : citiesContainer;
		const targetDetailsContainer = isPopup ? popupDetails : detailsContainer;

		if ( targetChipsContainer ) {

			targetChipsContainer.querySelectorAll( '.locations__chip[data-location]' ).forEach( chip => {

				chip.setAttribute( 'aria-pressed', 'false' );

			} );

		}

		button.setAttribute( 'aria-pressed', 'true' );

		if ( targetDetailsContainer ) {

			targetDetailsContainer.innerHTML = '<div class="locations__loading">Loading location details...</div>';

		}

		const formData = new FormData();
		formData.append( 'action', 'get_location_details' );
		formData.append( 'location_id', locationId );
		formData.append( 'nonce', window.locationsAjax.nonce );

		fetch( window.locationsAjax.ajaxUrl, {
			method: 'POST',
			body: formData,
		} )
			.then( response => response.json() )
			.then( data => {

				if ( data.success && data.data.details_html ) {

					if ( targetDetailsContainer ) {

						const detailsContainerPosition = detailsContainer?.getBoundingClientRect().top + window.pageYOffset;
						targetDetailsContainer.innerHTML = data.data.details_html;
						if ( detailsContainerPosition ) {

							window.scrollTo( {
								top: detailsContainerPosition,
								behavior: 'smooth'
							} );

						}

					}

				} else if ( targetDetailsContainer ) {

					targetDetailsContainer.innerHTML = '<div class="locations__error">Error loading location details. Please try again.</div>';

				}

			} )
			.catch( () => {

				if ( targetDetailsContainer ) {

					targetDetailsContainer.innerHTML = '<div class="locations__error">Error loading location details. Please try again.</div>';

				}

			} );

	}

	/**
	 * Handle back button click
	 */
	function handleBackClick() {

		citiesSection.hidden = true;
		countrySection.hidden = false;
		detailsContainer.textContent = '';

		updateCountryMap( globalMapUrl );

		document.querySelectorAll( '.locations__chip[data-country]' ).forEach( chip => {

			chip.setAttribute( 'aria-pressed', 'false' );

		} );

	}

	/**
	 * Add city hover highlight functionality for map points
	 *
	 * @param {boolean} isPopup Whether to setup for popup context
	 */
	function setupCityHoverHighlight( isPopup = false ) {

		const targetChipsContainer = isPopup ? popupCitiesChips : citiesContainer;
		const targetMapContainer = isPopup ? popupMapContainer : mapContainer;

		if ( !targetChipsContainer || !targetMapContainer ) {

			return;

		}

		const locationChips = targetChipsContainer.querySelectorAll( '.locations__chip[data-location]' );

		locationChips.forEach( chip => {

			const locationId = chip.dataset.location;

			chip.addEventListener( 'mouseenter', () => {

				const matchingPoints = targetMapContainer.querySelectorAll( `[data-post-id="${locationId}"]` );
				matchingPoints.forEach( point => {

					point.classList.add( 'locations__map-point--active' );

				} );

			} );

			chip.addEventListener( 'mouseleave', () => {

				const allPoints = targetMapContainer.querySelectorAll( '.locations__map-point' );
				allPoints.forEach( point => {

					point.classList.remove( 'locations__map-point--active' );

				} );

			} );

		} );

	}

	/**
	 * Add country hover highlight functionality
	 */
	function setupCountryHoverHighlight() {

		countryChips.forEach( chip => {

			const countryCode = chip.dataset.countrySlug;

			chip.addEventListener( 'mouseenter', () => {

				const matchingPath = mapContainer.querySelector( `svg path[data-country-id="${countryCode}"]` );
				if ( matchingPath ) {

					matchingPath.classList.add( 'locations__map--active' );

				}

			} );

			chip.addEventListener( 'mouseleave', () => {

				const svgPaths = mapContainer.querySelectorAll( 'svg path[data-country-id]' );
				svgPaths.forEach( path => {

					path.classList.remove( 'locations__map--active' );

				} );

			} );

		} );

	}

	/**
	 * Mobile Popup Functions
	 */

	// Popup elements
	const popup = block.querySelector( '.locations__mobile-popup' );
	const popupOverlay = popup?.querySelector( '[data-popup-overlay]' );
	const popupClose = popup?.querySelector( '[data-popup-close]' );
	const viewMapButton = block.querySelector( '[data-view-map]' );

	// Popup containers
	const popupMapContainer = popup?.querySelector( '[data-popup-map]' );
	const popupCountriesSection = popup?.querySelector( '[data-popup-countries]' );
	const popupCitiesSection = popup?.querySelector( '[data-popup-cities]' );
	const popupCountriesChips = popup?.querySelector( '[data-popup-countries-chips]' );
	const popupCitiesChips = popup?.querySelector( '[data-popup-cities-chips]' );
	const popupCitiesTitle = popup?.querySelector( '[data-popup-cities-title]' );
	const popupDetails = popup?.querySelector( '[data-popup-details]' );
	const popupBackButton = popup?.querySelector( '[data-popup-back]' );

	// Store focus element for return
	let lastFocusedElement = null;

	/**
	 * Open mobile popup
	 */
	function openMobilePopup() {

		if ( !popup ) {

			return;

		}

		// Store last focused element
		lastFocusedElement = block.ownerDocument.activeElement;

		// Show popup
		popup.removeAttribute( 'hidden' );

		// Lock body scroll
		document.body.classList.add( 'popup-open' );

		// Load global map into popup
		updateCountryMap( globalMapUrl, {}, popupMapContainer );

		// Clone country chips to popup
		if ( countryChips && popupCountriesChips ) {

			popupCountriesChips.innerHTML = '';

			countryChips.forEach( chip => {

				const clone = chip.cloneNode( true );
				const wrapper = document.createElement( 'div' );
				wrapper.className = 'wp-block-buttons';
				const buttonWrapper = document.createElement( 'div' );
				buttonWrapper.className = 'wp-block-button is-style-with-border';
				buttonWrapper.appendChild( clone );
				wrapper.appendChild( buttonWrapper );
				popupCountriesChips.appendChild( wrapper );

				// Add click handler for popup country selection
				clone.addEventListener( 'click', ( event ) => handleCountryClickContext( event, true ) );

			} );

		}

		// Setup popup hover highlighting
		setupPopupCountryHoverHighlight();

		// Reset to countries view
		if ( popupCountriesSection && popupCitiesSection ) {

			popupCountriesSection.hidden = false;
			popupCitiesSection.hidden = true;

		}

		// Set focus to close button
		setTimeout( () => {

			if ( popupClose ) {

				popupClose.focus();

			}

		}, 100 );

	}

	/**
	 * Close mobile popup
	 */
	function closeMobilePopup() {

		if ( !popup ) {

			return;

		}

		// Hide popup
		popup.setAttribute( 'hidden', '' );

		// Unlock body scroll
		document.body.classList.remove( 'popup-open' );

		// Reset popup to initial state
		if ( popupCountriesSection && popupCitiesSection ) {

			popupCountriesSection.hidden = false;
			popupCitiesSection.hidden = true;

		}

		// Clear cities and details
		if ( popupCitiesChips ) {

			popupCitiesChips.innerHTML = '<div class="locations__loading">Loading locations...</div>';

		}

		if ( popupDetails ) {

			popupDetails.innerHTML = '';

		}

		// Return focus
		if ( lastFocusedElement ) {

			lastFocusedElement.focus();
			lastFocusedElement = null;

		}

	}

	/**
	 * Handle country click in popup or desktop
	 *
	 * @param {Event} event Click event
	 * @param {boolean} isPopup Whether click is from popup
	 */
	function handleCountryClickContext( event, isPopup = false ) {

		const button = event.currentTarget;
		const countryId = button.dataset.country;

		if ( !countryId ) {

			return;

		}

		const countryName = button.textContent.trim();

		// Determine target containers
		const targetCitiesTitle = isPopup ? popupCitiesTitle : citiesTitle;
		const targetCitiesContainer = isPopup ? popupCitiesChips : citiesContainer;
		const targetDetailsContainer = isPopup ? popupDetails : detailsContainer;
		const targetMapContainer = isPopup ? popupMapContainer : mapContainer;
		const targetCountriesSection = isPopup ? popupCountriesSection : countrySection;
		const targetCitiesSection = isPopup ? popupCitiesSection : citiesSection;

		if ( targetCitiesTitle ) {

			targetCitiesTitle.textContent = countryName;

		}

		if ( targetCitiesContainer ) {

			targetCitiesContainer.innerHTML = '<div class="locations__loading">Loading locations...</div>';
			targetCitiesContainer.classList.add( 'locations__chips--loading' );

		}

		if ( targetDetailsContainer ) {

			targetDetailsContainer.innerHTML = '';

		}

		if ( targetCountriesSection && targetCitiesSection ) {

			targetCountriesSection.hidden = true;
			targetCitiesSection.hidden = false;

		}

		const formData = new FormData();
		formData.append( 'action', 'get_locations_by_country' );
		formData.append( 'country_id', countryId );
		formData.append( 'nonce', window.locationsAjax.nonce );

		fetch( window.locationsAjax.ajaxUrl, {
			method: 'POST',
			body: formData,
		} )
			.then( response => response.json() )
			.then( data => {

				if ( targetCitiesContainer ) {

					targetCitiesContainer.classList.remove( 'locations__chips--loading' );

				}

				if ( data.success && data.data.locations_html ) {

					if ( targetCitiesContainer ) {

						targetCitiesContainer.innerHTML = data.data.locations_html;

					}

					if ( targetDetailsContainer ) {

						targetDetailsContainer.innerHTML = '<div class="locations__instructions">Select a location to view details</div>';

					}

					updateCountryMap( data.data.map_url, data.data.coordinates, targetMapContainer );

					// Attach location listeners
					attachLocationListeners( isPopup );

				} else {

					if ( targetCitiesContainer ) {

						targetCitiesContainer.innerHTML = '<div class="locations__no-results">No locations found for this country.</div>';

					}

					updateCountryMap( null, {}, targetMapContainer );

				}

			} )
			.catch( () => {

				if ( targetCitiesContainer ) {

					targetCitiesContainer.classList.remove( 'locations__chips--loading' );
					targetCitiesContainer.innerHTML = '<div class="locations__error">Error loading locations. Please try again.</div>';

				}

			} );

	}

	/**
	 * Setup country hover highlight for popup
	 */
	function setupPopupCountryHoverHighlight() {

		if ( !popupCountriesChips || !popupMapContainer ) {

			return;

		}

		const popupCountryButtons = popupCountriesChips.querySelectorAll( '.locations__chip[data-country]' );

		popupCountryButtons.forEach( chip => {

			const countryCode = chip.dataset.countrySlug;

			chip.addEventListener( 'mouseenter', () => {

				const matchingPath = popupMapContainer.querySelector( `svg path[data-country-id="${countryCode}"]` );
				if ( matchingPath ) {

					matchingPath.classList.add( 'locations__map--active' );

				}

			} );

			chip.addEventListener( 'mouseleave', () => {

				const svgPaths = popupMapContainer.querySelectorAll( 'svg path[data-country-id]' );
				svgPaths.forEach( path => {

					path.classList.remove( 'locations__map--active' );

				} );

			} );

		} );

	}

	/**
	 * Handle back button in popup
	 */
	function handlePopupBackClick() {

		if ( popupCitiesSection && popupCountriesSection ) {

			popupCitiesSection.hidden = true;
			popupCountriesSection.hidden = false;

		}

		// Restore global map
		updateCountryMap( globalMapUrl, {}, popupMapContainer );

		// Reset country buttons
		if ( popupCountriesChips ) {

			const chips = popupCountriesChips.querySelectorAll( '.locations__chip[data-country]' );
			chips.forEach( chip => {

				chip.setAttribute( 'aria-pressed', 'false' );

			} );

		}

	}

	/**
	 * Handle ESC key to close popup
	 *
	 * @param {KeyboardEvent} event Keyboard event
	 */
	function handleEscapeKey( event ) {

		if ( event.key === 'Escape' && popup && !popup.hasAttribute( 'hidden' ) ) {

			closeMobilePopup();

		}

	}

	// Initialize popup event listeners
	if ( viewMapButton ) {

		viewMapButton.addEventListener( 'click', openMobilePopup );

	}

	if ( popupClose ) {

		popupClose.addEventListener( 'click', closeMobilePopup );

	}

	if ( popupOverlay ) {

		popupOverlay.addEventListener( 'click', ( event ) => {

			if ( event.target === popupOverlay ) {

				closeMobilePopup();

			}

		} );

	}

	if ( popupBackButton ) {

		popupBackButton.addEventListener( 'click', handlePopupBackClick );

	}

	// ESC key listener
	document.addEventListener( 'keydown', handleEscapeKey );

	// Desktop initialization
	setupCountryHoverHighlight();

	countryChips.forEach( chip => {

		chip.addEventListener( 'click', handleCountryClick );

	} );

	if ( backButton ) {

		backButton.addEventListener( 'click', handleBackClick );

	}

} );
